import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {textarea} from '../../../styles/inputs/textarea.styles';
import {SpBaseInput} from '../sp-base-input';
import {property} from 'lit/decorators.js';
import {ifDefined} from 'lit/directives/if-defined.js';
import {live} from 'lit/directives/live.js';

@customElement('sp-textarea')
export class SpTextarea extends SpBaseInput<string> {
    static styles = [
        textarea
    ];

    @property() value;
    @property({type: Boolean, reflect: true}) disabled = false;
    @property({type: Boolean, reflect: true}) readonly = false;
    @property({type: Boolean, reflect: true }) required = false;
    @property({type: String}) placeholder: string;

    protected render() {
        return html`
            <textarea
                .value=${live(!!this.value ? this.value : '')}
                @input=${event => {
                    this.value = event.target.value;
                }}
                ?disabled=${this.disabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                placeholder=${ifDefined(this.placeholder)}></textarea>
        `;
    }
}
